/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { debounce } from "lodash";

import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

/**
 * @COMPONENT_NAME StaticColor
 * @DESCRIPTION 다른 화면에 임베드하여 기준 색상(StaticColor) 목록을 선택할 수 있는 컴포넌트입니다.
 *
 * @PROPS
 *   - {Function} onSelect - 기준 색상 선택 시 호출되는 콜백 함수 (선택된 row 객체 전달)
 *   - {Function} onApiInitialized - API 초기화 시 호출되는 콜백 함수
 *
 * @CALLBACKS
 *   - {Function} onSelect - 기준 색상이 선택되었을 때 부모 컴포넌트에 알림
 *
 * @USAGE
 *   <StaticColor onSelect={...} onApiInitialized={...} />
 *
 * @DESCRIPTION
 *   - 기준 색상(StaticColor) 목록을 그리드로 보여주고, 행 선택 시 onSelect 콜백을 호출합니다.
 *   - 생성/수정/삭제/엑셀 기능 없이 조회만 지원합니다.
 */
function StaticColor(props) {
	const { t } = useTranslation();
	const { onSelect, onApiInitialized } = props;

	const table = "VwStaticColor";
	const view = "VwStaticColor";

	const [grid, setGrid] = useState();

	useEffect(() => {
		if (grid) {
			grid.selectionChanged.addHandler(
				debounce((grid, event) => {
					if (grid.selectedItems && grid.selectedItems[0]) {
						if (onSelect) {
							onSelect(grid.selectedItems[0]);
						}
					} else {
						if (onSelect) {
							onSelect([]);
						}
					}
				}, 10)
			);

			grid.itemsSourceChanged.addHandler(
				debounce((grid, event) => {
					if (grid.selectedItems && grid.selectedItems[0]) {
						if (onSelect) {
							onSelect(grid.selectedItems[0]);
						}
					} else {
						if (onSelect) {
							onSelect([]);
						}
					}
				}, 10)
			);
		}
	}, [grid, onSelect]);

	const onGridInitialized = (grid) => {
		grid.selectionMode = "Row";
		setGrid(grid);
	};

	return (
		<BasicCrudScreenType
			id={table}
			headerTitle={t("term.staticColor")}
			table={table}
			view={view}
			noCreate
			noEdit
			noDelete
			noExcel
			onInitialized={onGridInitialized}
			onApiInitialized={onApiInitialized}
		/>
	);
}

export default StaticColor;
